<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>Stroji</v-toolbar-title>
    </v-toolbar>
  </v-card>
</template>
